import type { Address, ResidentApplicationData } from '@/types/application'

export const ADDRESS_IMPORT_SUCCESS_MESSAGE =
  'Added Address data to Previous address, after completing current adddress it will show previous address list'

/** Offer address import when old app has data and current previous is empty (Angular importOldata). */
export function shouldOfferAddressImport(
  applicationData: ResidentApplicationData | null | undefined,
): boolean {
  if (!applicationData) return false

  const oldApp = applicationData.oldapplication
  if (!oldApp?.user_data) return false

  const hasOldAddressData =
    Boolean(
      oldApp.current_address &&
        (oldApp.current_address as { address_data?: unknown }).address_data,
    ) ||
    (Array.isArray(oldApp.previous_address) && oldApp.previous_address.length > 0)
  if (!hasOldAddressData) return false

  const previous = applicationData.previous_address
  const previousEmpty =
    !previous || (Array.isArray(previous) && previous.length === 0)
  if (!previousEmpty) return false

  const current = applicationData.current_address
  if (Array.isArray(current)) {
    return current.length === 0
  }
  // Angular `!current_address.length` — object current_address has no numeric length.
  return Boolean(current && typeof current === 'object')
}

/** Patched application data after address import — Angular setOldApplicationData('neutral'). */
export function buildAddressImportUpdate(
  applicationData: ResidentApplicationData,
): ResidentApplicationData | null {
  const oldApp = applicationData.oldapplication
  if (!oldApp?.user_data) return null

  const merged: Address[] = []
  if (oldApp.current_address) merged.push(oldApp.current_address)
  if (Array.isArray(oldApp.previous_address)) {
    oldApp.previous_address.forEach((row) => merged.push(row))
  }
  if (merged.length === 0) return null

  return {
    ...applicationData,
    previous_address: merged,
  }
}
